/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Marker_LabelInputs */

const en_ui_studio_marker_label = /** @type {(inputs: Ui_Studio_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label`)
};

const de_ui_studio_marker_label = /** @type {(inputs: Ui_Studio_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezeichnung`)
};

/**
* | output |
* | --- |
* | "Label" |
*
* @param {Ui_Studio_Marker_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_marker_label = /** @type {((inputs?: Ui_Studio_Marker_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Marker_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_marker_label(inputs)
	return de_ui_studio_marker_label(inputs)
});